<template>
  <section class="component-b80a8704" resmed-component-name="executive-team">
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="row">
          <div
            class="col-sm-6 col-md-4 col-lg-3 item"
            v-for="(item, index) in acf.items"
          >
            <figure>
              <img
                class="img-fluid"
                v-on:click.prevent="overlay(item)"
                v-bind:src="item.portrait"
                v-bind:alt="item.title"
              />

              <figcaption>
                <div v-on:click.prevent="overlay(item)" style="cursor: pointer">
                  <h5>{{ item.title }}</h5>
                  <div class="position">
                    <p>{{ item.position }}</p>
                  </div>
                </div>

                <div class="call-to-action">
                  <a
                    href="#"
                    class="btn cta-plain text-red icon move-expand"
                    v-on:click.prevent="overlay(item)"
                    >Read bio</a
                  >
                  <a
                    v-if="item.twitter"
                    v-bind:href="item.twitter"
                    target="_blank"
                    class="btn twitter"
                  ></a>
                </div>
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </div>

    <modal-b80a8704
      v-bind:content="modal.content"
      v-bind:active.sync="modal.active"
    ></modal-b80a8704>
  </section>
</template>

<script>
import modalB80a8704 from "../shared-support/modal-b80a8704";

export default {
  name: "component-b80a8704", // executive-team
  props: ["acf"],
  components: {
    modalB80a8704,
  },
  data() {
    return {
      modal: {
        active: false,
        content: {},
      },
    };
  },
  watch: {
    "modal.active"(val) {
      document.body.style["overflow"] = val ? "hidden" : "visible";
    },
  },
  methods: {
    overlay(arg) {
      this.modal.active = true;
      this.modal.content = arg;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

$offset: -9rem;

.component-b80a8704 {
  padding: 5rem 0 4rem 0;
  margin-bottom: $offset;
  background-color: #eef3f8;
}

.component {
  transform: translateY($offset);

  h5 {
    position: relative;
    margin-bottom: 0.5rem;

    @extend %eyebrow-left;
  }

  .item {
    align-items: stretch;
    display: flex;
    margin-bottom: 20px; // grid gutter 10px (x2)

    figure {
      display: flex;
      flex-direction: column;
      box-shadow: 0 7px 15px 0 rgba(0, 0, 0, 0.14);
      background-color: $cc-resmed-white;
      border-radius: 6px;
      overflow: hidden;

      &:hover {
        figcaption {
          background-color: $cc-resmed-bg-grey-2;
        }
      }

      img {
        cursor: pointer;
      }

      figcaption {
        position: relative;
        background-color: $cc-resmed-white;
        padding: 2rem 1.25rem 1.25rem 1.25rem;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        transition: all 0.5s;

        p {
          margin-bottom: 1.75rem;
        }

        > div:first-child {
          flex-grow: 1;
        }

        .position {
          flex-grow: 1;
        }
      }
    }

    .call-to-action {
      display: flex;
      justify-content: space-between;

      .twitter {
        display: block;
        width: 1rem;
        height: 1rem;
        padding: 0;
        background-position: center center;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url(#{$assets}/images/social-media-icon-twitter.svg);
      }
    }
  }
}
</style>